const en = require("./en.json");
const tr = require("./tr.json");

export default {
  en,
  tr,
};
